import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { isNumber } from 'highcharts';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { GridComponent, PageSettingsModel, RowDeselectEventArgs, RowSelectEventArgs, SelectionSettingsModel, ToolbarItems, ContextMenuItemModel } from '@syncfusion/ej2-angular-grids';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MovimientoService, MenuFuncionService, MonedaService, AlicuotaIvaService, TipoMovimientoService, TenantService, ConsorcioService, ComunidadService, UnidadFuncionalService, ProveedorService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, Moneda, Movimiento, SearchAlicuotaIvaRequest, SearchMonedaRequest, AlicuotaIva, TipoMovimiento, SearchConsorcioRequest, SearchComunidadRequest, SearchUnidadFuncionalRequest, DialogCargaMovimientoItem,
  SearchTipoMovimientoRequest, LocalStorageKeys, TenantFeatureFlags, UnidadFuncional, EstadoConstants, FinanciarDeudaDto, Proveedor, SearchProveedorRequest, SearchGastoItem, SearchMovimientoRequest, Comunidad, Consorcio
 } from '../../../../src/app/shared/model';

import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';

@Component({
  selector: 'app-movimientoFinanciacion',
  templateUrl: './movimientoFinanciacion.component.html',
  styles: []
})

export class MovimientoFinanciacionComponent implements OnInit {

  @ViewChild('deudasPendientesGrid')
  public deudasPendientesGrid: GridComponent;
  @ViewChild('grid')
  public grid: GridComponent;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  formGroup: FormGroup;
  financiacionFormGroup: FormGroup;
  searchDeudaForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;
  isFileAttaching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isMovimientoDeudaSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isMonedaSearching: boolean = false;

  movimientoAdjuntoBase64: string | ArrayBuffer | null;
  movimientoAdjuntoExtension: string = "";

  canEdit: boolean = false;
  isEditing: boolean = false;

  msgError: string = "";
  item: Movimiento;

  alicuotaIvaList: AlicuotaIva[];
  monedaList: Moneda[];
  tipoMovimientoList: TipoMovimiento[];
  deudasPendientesList: any[];
  deudasSeleccionadasList: any[] = [];
  consorcioList: Consorcio[];
  comunidadList: Comunidad[];
  ufList: UnidadFuncional[];
  filteredProveedorList: Proveedor[] = [];
  movimientoList: DialogCargaMovimientoItem[];

  tenantFeatureFlags: TenantFeatureFlags;

  monedaDeuda: string = "";
  totalPorPagar: number = 0;
  montoIva: number = 0;
  montoPendiente: number = 0;
  montoCuota: number = 0;

  public deudaSelectionOptions?: SelectionSettingsModel;

  public contextMenuItems: ContextMenuItemModel[];

  private readonly gridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha Movimiento' },
    { field: 'FechaVencimiento', headerText: 'FechaVencimiento' },
    { field: 'CuentaImputada', headerText: 'Referencia' },
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'TipoMovimientoNombre', headerText: 'Tipo' },
    { field: 'Monto', headerText: 'Total' },
    { field: 'Saldo', headerText: 'Pendiente' },
    { field: 'SaldoConvertido', headerText: 'Saldo Convertido' },
  ]

  // private readonly gridFormasPago = [
  //   { field: 'FechaInicioCuota', headerText: 'Fecha' },
  //   { field: 'TipoMovimiento', headerText: 'Tipo' },
  //   { field: 'Importe', headerText: 'Importe' },
  //   { field: 'CantidadCuotas', headerText: 'Cuotas' },
  //   { field: 'DiasRepeticionCuotas', headerText: 'Periodicidad' },
  //   { field: 'PorcentajeAjusteCuota', headerText: 'Ajuste' },
  //   { field: 'AplicarAjusteIncremental', headerText: 'Incremental?' },
  // ]

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private tipoMovimientoService: TipoMovimientoService,
    private tenantService: TenantService,
    private alicuotaIvaService: AlicuotaIvaService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private proveedorService: ProveedorService,
    private monedaService: MonedaService,
    private movimientoService: MovimientoService
  ) {
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_FINANCIACION);
            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
    this.contextMenuItems = this.sharedFunctions.initializeContextMenu(this.gridColumns);
  }

  loadView() {
    this.buildForm();
    this.buildFormFinanciacion();

    this.getConsorcios();
    this.getComunidades();
    this.getProveedoresAutocomplete();

    this.getMonedas();
    this.getTiposMovimientos();
    this.getAlicuotaIva();

    this.deudasPendientesList = [];

    this.item = new Movimiento(0, null, null, null, null, null, null, null, null, null, null, null, null, new Date(), new Date(), null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, [], null, null, null, false);
    this.formGroup.patchValue(this.item);
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Detalle': [null, [Validators.required, Validators.maxLength(100)]],
      'AlicuotaIvaId': [0, Validators.required],
      'Observacion': [null, Validators.maxLength(300)],
    });

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchDeudaForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [new Date()],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],
      'Detalle': [null],
      'MonedaId': [null],

      'PedidoId': [null],
      'Contrato': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'Proveedor': [null],

      'VerSoloAsociadosAUfs': [false]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-buscadorMovimientosDeuda");
    if (filtros != null) {
      this.searchDeudaForm.patchValue(filtros);
      if (filtros.ComunidadId != null && filtros.ComunidadId > 0)
        this.onDeudaFiltroUfComunidadSelect(false);
      setTimeout(() => this.searchGastosPendientes(), 100);
    }
  }

  buildFormFinanciacion() {
    this.financiacionFormGroup = this.formBuilder.group({
      'grid-index': [null],
      'TipoMovimientoId': [null, Validators.required],
      'Importe': [this.montoPendiente, Validators.required],
      'CantidadCuotas': [1, Validators.min(1)],
      'FechaInicioCuota': [new Date()],
      'DiasRepeticionCuotas': [30],
      'PorcentajeAjusteCuota': [0, [Validators.min(0), Validators.max(100)]],
      'AplicarAjusteIncremental': [false],
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving);
  }

  getProveedoresAutocomplete() {
    this.searchDeudaForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  getTiposMovimientos() {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, -1, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;
      this.tipoMovimientoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    this.isMonedaSearching = true;
    let searchAllMonedas = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.monedaService.search(searchAllMonedas).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null,null,null,null,null,null,null,null,true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onDeudaFiltroUfComunidadSelect(clearUf: boolean = true) {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    if (clearUf)
      this.searchDeudaForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchDeudaForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onAlicuotaIvaSelect() {
    this.calcularMontos();
  }

  calcularMontos() {
    this.calcularTotalPorPagar();

    var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
    if (alicuota != null && alicuota.Id > 0)
      this.montoIva = ((this.financiacionFormGroup.get('Importe')?.value ?? 0) * (alicuota.Porcentaje / 100));
    else
      this.montoIva = 0;

    var monto = (this.financiacionFormGroup.get('Importe')?.value ?? 0) + this.montoIva;
    this.montoCuota = (monto * (1 + ((this.financiacionFormGroup.get('PorcentajeAjusteCuota')?.value ?? 0) / 100))) / (this.financiacionFormGroup.get("CantidadCuotas")?.value ?? 1);
  }

  getErrorDetalle() {
    var v = this.formGroup.get('Detalle');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorAlicuotaIvaId() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoMovimientoId() {
    return this.financiacionFormGroup.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorImporte() {
    var v = this.financiacionFormGroup.get('Importe');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorCantidadCuotas() {
    var v = this.financiacionFormGroup.get('CantidadCuotas');
    if (v?.hasError('min'))
      return 'Debe ingresar un valor mayor a 0';
    return '';
  }

  getErrorFechaInicioCuota() {
    var v = this.financiacionFormGroup.get('FechaInicioCuota');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDiasRepeticionCuotas() {
    var v = this.financiacionFormGroup.get('DiasRepeticionCuotas');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorPorcentajeAjusteCuota() {
    var v = this.financiacionFormGroup.get('PorcentajeAjusteCuota');
    if (v?.hasError('min'))
      return 'El porcentaje debe ir entre 0 y 100';
    if (v?.hasError('max'))
      return 'El porcentaje debe ir entre 0 y 100';
    return '';
  }

  onClean() {
    this.buildFormFinanciacion();

    this.montoCuota = 0;
    this.isEditing = false;
  }

  onSave() {

    if (!this.financiacionFormGroup.valid) {
      this.sharedFunctions.showMessage("Debe completar todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var gridIndex = (this.financiacionFormGroup.get("grid-index")?.value ?? -1);

    var r = new DialogCargaMovimientoItem(null, 0, null, 0, null, null, null, false, false, null, null);
    r = { ...this.financiacionFormGroup.value };
    r.TipoMovimiento = this.tipoMovimientoList?.find(f => f.Id == r.TipoMovimientoId)?.Nombre ?? null;

    if (this.movimientoList == null)
      this.movimientoList = [];

    if (gridIndex >= 0)
      this.movimientoList[gridIndex] = r;
    else
      this.movimientoList.push(r);

    this.grid.refresh();

    this.updateTotalPendiente();
    this.onClean();
  }

  onEdit(data: any) {
    if (data != null) {
      this.financiacionFormGroup.patchValue(data);
      this.financiacionFormGroup.get("grid-index")?.setValue(data.index);
      this.isEditing = true;
    }
  }

  onDelete(data: any) {
    if (data != null && data.index >= 0) {
      this.movimientoList.splice(data.index, 1);
      this.grid.refresh();
      this.updateTotalPendiente();
    }
  }

  updateTotalPendiente() {
    var totalMovimientos = this.movimientoList?.reduce(function (accumulator, mov) {
      return accumulator + (mov.Importe != null ? parseFloat(mov.Importe.toString()) : 0);
    }, 0);

    this.montoPendiente = (this.totalPorPagar ?? 0) - (totalMovimientos ?? 0);
  }

  clearDeudaDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchDeudaForm.get(formFieldName) != null && this.searchDeudaForm.get(formFieldName)?.value)
            this.searchDeudaForm.get(formFieldName)?.setValue(null);
    }
  }

  searchGastosPendientes() {
    this.sharedFunctions.setReporteFiltros("app-buscadorMovimientosDeuda", this.searchDeudaForm.getRawValue());

    var search = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, true, false, null);

    search = {
      ...search,
      ...this.searchDeudaForm.value,
      ... {
        Estados: [ EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO.toString() ],
        VerSoloDeudasPendientes: true,
        VerSoloActivos: true,
        MonedaConversionId: this.formGroup.get("Moneda")?.value?.Id,
        ProveedorId: this.searchDeudaForm.get("Proveedor")?.value?.Id
      }
    }

    this.isMovimientoDeudaSearching = true;
    this.movimientoService.search(search).subscribe(data => {
      this.isMovimientoDeudaSearching = false;
      this.deudasPendientesList = data?.result;

      this.calcularTotalPorPagar();
    },
    (err: HttpErrorResponse) => {
      this.isMovimientoDeudaSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDeudaDataBound(args: any) {
    var seleccionados = this.deudasPendientesList?.filter(f => f.Seleccionado == true);

    // Restaurar la selección de filas
    if (seleccionados != null && seleccionados.length > 0) {
      var pageRows = this.deudasPendientesGrid.getRowsObject();
      if (pageRows != null && pageRows.length > 0) {
        var indexes : number[] = [];
        for (var i=0; i<pageRows.length; i++) {
          if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
            indexes.push(pageRows[i].index);
        }

        if (indexes != null && indexes.length > 0)
          this.deudasPendientesGrid.selectRows(indexes);
      }
    }
  }

  public onDeudaRowSelect(args: RowSelectEventArgs): void {
    if (args.isHeaderCheckboxClicked) {
      // var multiSelection = this.deudasPendientesGrid.getRowsObject();
      // if (multiSelection != null && multiSelection.length > 0) {
      //   for (var i=0; i<multiSelection.length; i++)
      //     this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = true;
      // }
      for (var i=0; i<this.deudasPendientesList.length; i++)
        this.deudasPendientesList[i].Seleccionado = true;
    }
    else {
      if (args?.data != null && (args?.data as any).Id != null)
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
    }

    this.calcularTotalPorPagar();
  }

  onDeudaRowDeselected(args: RowDeselectEventArgs ): void {
    //Solo cuando hace click en el checkbox de la grilla deselecciona
    if (args.isHeaderCheckboxClicked) {
      // var multiSelection = this.deudasPendientesGrid.getRowsObject();
      // if (multiSelection != null && multiSelection.length > 0) {
      //   for (var i=0; i<multiSelection.length; i++)
      //     this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = false;
      // }
      for (var i=0; i<this.deudasPendientesList.length; i++)
        this.deudasPendientesList[i].Seleccionado = false;
    }
    else {
      if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck")
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
    }

    this.calcularTotalPorPagar();
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var deudaList = this.deudasPendientesGrid.getSelectedRecords();
    if (deudaList == null || deudaList.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar al menos una deuda para realizar la financiación", "Error");
      return false;
    }

    var r = new FinanciarDeudaDto(null, null, null, null, null, null, null, null, false, [])

    r = {
      ...this.formGroup.value,
      MovimientosDeuda: deudaList,
      Financiacion: this.movimientoList
    };

    this.isSaving = true;
    this.movimientoService.financiarDeuda(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.sharedFunctions.reloadCurrentRoute();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  calcularTotalPorPagar() {
    this.totalPorPagar = 0;

    if (this.deudasPendientesGrid != null) {
      // var filasSeleccionadas = this.deudasPendientesGrid.getSelectedRecords() as any[];
      var filasSeleccionadas = this.deudasPendientesList.filter(f => f.Seleccionado == true);
      // console.log(filasSeleccionadas);
      if (filasSeleccionadas != null && filasSeleccionadas.length > 0) {
        this.monedaDeuda = filasSeleccionadas[0].Moneda;
        this.totalPorPagar += filasSeleccionadas.reduce((total, item) => total - item.SaldoConvertido, 0);
      }

      this.updateTotalPendiente();
    }

    return this.totalPorPagar;
  }

  contextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.deudasPendientesGrid, this.gridColumns);
  }

  contextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.deudasPendientesGrid, this.gridColumns)
  }

}
